import React, { useEffect, useState } from 'react';
//import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

//import { language } from './Language';

//import Calendar from '@toast-ui/react-calendar';
import 'tui-calendar/dist/tui-calendar.css';

// If you use the default popups, use this.
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';

export default function View(props) {

    const [isloading, setLoading] = useState(true);
    //const [refresh, setRefresh] = useState(0);

	const [/*lang*/, set_lang] = useState('pt');

    useEffect(() => {
        //const companycode = getTokenInfo().companycode;
        
        set_lang(localStorage.getItem('lang'))
        setLoading(false)
        
    }, [props]);


    return (isloading ?
        
        <Loader />

    :
        <main>

        </main>
    )
}
